<template>
  <fieldset class="fieldset">
    <legend class="fieldset__label">{{ title }}</legend>
    <div class="search-filter__dates">
      <div class="search-filter__date">
          <input type="radio" name = "period" id = "month" value="rad1" 
             @click="handleRadioClick"> 
          <label for="month">по месяцам</label>
      </div>

      <div class="search-filter__date">
          с &nbsp;&nbsp;
          <select id="monthFrom" @change="handleChangeMonth(1)" >
            <option>              </option>
            <option value="val0">{{dates[0]}}</option>
            <option value="val1">{{dates[1]}}</option>
            <option value="val2">{{dates[2]}}</option>
            <option value="val3">{{dates[3]}}</option>
            <option value="val4">{{dates[4]}}</option>
            <option value="val5">{{dates[5]}}</option>
            <option value="val6">{{dates[6]}}</option>
            <option value="val7">{{dates[7]}}</option>
            <option value="val8">{{dates[8]}}</option>
            <option value="val9">{{dates[9]}}</option>
            <option value="val10">{{dates[10]}}</option>
            <option value="val11">{{dates[11]}}</option>          </select>
      </div>

      <div class="search-filter__date">
          по &nbsp;
          <select id="monthTo" @change="handleChangeMonth(2)">
            <option>              </option>
            <option value="val0">{{dates[0]}}</option>
            <option value="val1">{{dates[1]}}</option>
            <option value="val2">{{dates[2]}}</option>
            <option value="val3">{{dates[3]}}</option>
            <option value="val4">{{dates[4]}}</option>
            <option value="val5">{{dates[5]}}</option>
            <option value="val6">{{dates[6]}}</option>
            <option value="val7">{{dates[7]}}</option>
            <option value="val8">{{dates[8]}}</option>
            <option value="val9">{{dates[9]}}</option>
            <option value="val10">{{dates[10]}}</option>
            <option value="val11">{{dates[11]}}</option>
          </select>
      </div>
    </div>

    <div class="search-filter__dates">
      <div class="search-filter__date">
          <input type="radio" name = "period" id = "day" value="rad2" 
           @click="handleRadioClick"> 
          <label for="day">по дням</label>        
      </div>

      <div class="search-filter__date">
          с &nbsp;
          <input type="date" id = "dayFrom" :value = "dayFromValue" @change="handleChangeDay(1)">
      </div>

      <div class="search-filter__date">
          по
          <input type="date" id = "dayTo" :value = "dayToValue" @change="handleChangeDay(2)">
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    bMonth: {
      type: Boolean,
      default: () => true
    },
    dayFromValue: {
      type: String,
      default: () => ''
    },
    dayToValue: {
      type: String,
      default: () => ''
    },
    monthFromValue: {
      type: String,
      default: () => ''
    },
    monthToValue: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      dates: [],
      dates_full: [],
      dayFromDay: "",
      dayToDay: "",
      dayFromMonth: "",
      dayToMonth: ""
    };
  },

  /*async created() {
    let a = this.monthFromValue;
    debugger;
  },*/

  watch: {
    monthFromValue: function() {
      if (this.monthFromValue == "") {
        var e = document.getElementById("monthFrom");
        e.selectedIndex = 0;
      }
    },
    monthToValue: function() {
      if (this.monthToValue == "") {
        var e = document.getElementById("monthTo");
        e.selectedIndex = 0;
      }
    }
  },

  mounted() {
    var date = new Date();
    var months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", 
      "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
    var month = date.getMonth();
    var year = date.getFullYear();
    month -= 11;
    if (month < 0) {
      month += 12;
      year--;
    }
    let nameDate = months[month] + " " + year.toString();
    this.dates.push(nameDate);
    this.dates_full.push({month: month, year: year})
    for (let i = 0; i < 12; i++) {
      month++;
      if (month > 11) {
        month = 0;
        year++;
      }
      nameDate = months[month] + " " + year.toString();
      this.dates.push(nameDate);
      this.dates_full.push({month: month, year: year})
    }

    // создание атрибута
    var attrChecked = document.createAttribute("checked");
    var attrsMonthFrom = document.getElementById(this.bMonth ? "month" : "day").attributes;
    // добавление атрибута в массив атрибутов элемента
    attrsMonthFrom.setNamedItem(attrChecked);

    this.setAttr();

    // позиционирование на нужную строку элементов monthFrom, monthTo
    var e = document.getElementById("monthFrom");
    for (let i = 0; i < 12; i++) {
      if (this.dates[i].toLowerCase() == this.monthFromValue) {
        e.selectedIndex = i + 1;
      }
    }
    var e1 = document.getElementById("monthTo");
    for (let i = 0; i < 12; i++) {
      if (this.dates[i].toLowerCase() == this.monthToValue) {
        e1.selectedIndex = i + 1;
      }
    }
  },

  methods: {
    handleRadioClick(e) {
      this.bMonth = e.target.value === "rad1";
      if (this.bMonth) {
        this.correctDays(1);
        this.correctDays(2);
      }
      this.setAttr();
      this.createMessage();
    },

    // установка атрибутов disabled/enabled для элементов
    setAttr() {
      var attrsMonthFrom = document.getElementById("monthFrom").attributes;
      var attrsMonthTo = document.getElementById("monthTo").attributes;
      var attrsDayFrom = document.getElementById("dayFrom").attributes;
      var attrsDayTo = document.getElementById("dayTo").attributes;

      // перебор всех атрибутов в цикле
      /*for (var i = 0, length = attrsMonthTo.length; i < length; i++) {
        console.log(attrsMonthTo[i].name + ' = ' + attrsMonthTo[i].value);
      }*/
      
      if (!this.bMonth) {
        // создание атрибута
        var attrDisabled = document.createAttribute('disabled');
        attrDisabled.value = "disabled"
        // добавление атрибута в массив атрибутов элемента
        attrsMonthFrom.setNamedItem(attrDisabled);
        // создание атрибута
        var attrDisabled1 = document.createAttribute('disabled');
        attrDisabled1.value = "disabled"
        // добавление атрибута в массив атрибутов элемента
        attrsMonthTo.setNamedItem(attrDisabled1);

        try {
          // удаление атрибута
          attrsDayFrom.removeNamedItem("disabled");
        }
        catch {}
        try {
          // удаление атрибута
          attrsDayTo.removeNamedItem("disabled");
        }
        catch {}
      }
      else {
        try {
          // удаление атрибута
          attrsMonthFrom.removeNamedItem("disabled");
        }
        catch {}
        try {
          // удаление атрибута
          attrsMonthTo.removeNamedItem("disabled");
        }
        catch {}
        
        // создание атрибута
        var attrDisabled = document.createAttribute('disabled');
        attrDisabled.value = "disabled"
        // добавление атрибута в массив атрибутов элемента
        attrsDayFrom.setNamedItem(attrDisabled);
        // создание атрибута
        var attrDisabled1 = document.createAttribute('disabled');
        attrDisabled1.value = "disabled"
        // добавление атрибута в массив атрибутов элемента
        attrsDayTo.setNamedItem(attrDisabled1);
      }
    },

    handleChangeMonth(id) {
      this.correctDays(id);
      this.createMessage();
    },

    correctDays(id) {
      var e = document.getElementById(id === 1 ? "monthFrom" : "monthTo");
      //var value = e.value;
      var text = e.options[e.selectedIndex].text;
      var index = e.selectedIndex - 1;
      if(index >= 0) { 	
        var month = this.dates_full[index].month;
        var year = this.dates_full[index].year;
        var  day = (id === 2 ? 32 - new Date(year, month, 32).getDate() : 1);
        if (id == 1) {
          this.monthFromValue = text;
          this.dayFromMonth = String(year) + "-" + String(month + 1).padStart(2, "0") + "-" + 
             String(day).padStart(2, "0");
        }
        else {
          this.monthToValue = text;
          this.dayToMonth = String(year) + "-" + String(month + 1).padStart(2, "0") + "-" + 
            String(day).padStart(2, "0");
        }
      }
      else {
         if (id == 1) {
          this.monthFromValue = text;
          this.dayFromMonth = "";
        }
        else {
          this.monthToValue = text;
          this.dayToMonth = "";
        }
      }
    },

    handleChangeDay(id) {
      if (id == 1)
        this.dayFromValue = dayFrom.value;
      else
        this.dayToValue = dayTo.value;
      this.createMessage();
    },

    createMessage() {
      this.bMonth = month.checked;
      this.$emit('dates-add-changed', {
        bMonth: this.bMonth,
        monthFrom: this.monthFromValue.toLowerCase(),
        monthTo: this.monthToValue.toLowerCase(),
        dayFrom: this.bMonth ? this.dayFromMonth : this.dayFromValue,
        dayTo: this.bMonth ? this.dayToMonth : this.dayToValue,
        dayFromDay: this.dayFromValue,
        dayToDay: this.dayToValue
      })
    }
  }
}
</script>